module.exports = __webpack_public_path__ + "static/Beholder-c5ae8f72bcf449641d6254e0f1e5ee6f.jpg";